<template>
  <div class="content">
    <h3 class="title is-3">{{ job.title }}</h3>
    <p>
      Springbit is seeking an experienced software quality assurance professional to join our team.
      As a Software Tester, you'll be a critical part of delivering high quality software and
      business intelligence solutions. We aim to be the preferred software development partner to
      our clients through technical expertise, integrity, efficiency, and professionalism.
    </p>
    <p>
      Currently, our team is 100% remote, but this position will eventually require your presence on
      some days in the north Atlanta, GA area. No travel is required. Note that we are not currently
      sponsoring employment visas.
    </p>
    <h4 class="title is-4">What You'll Do</h4>
    <ul>
      <li>Manually exercise new features in web, mobile, and desktop apps</li>
      <li>Collaborate regularly with software developers to resolve defects</li>
      <li>Manipulate data in SQL Server to setup test scenarios</li>
      <li>Execute existing test plans</li>
      <li>Write detailed bugs with steps to reproduce</li>
      <li>Author or contribute to new test plans</li>
      <li>Construct SQL queries to verify data</li>
      <li>Maintain automated test scripts</li>
      <li>Participate in project stand ups</li>
      <li>Assist with customer acceptance testing</li>
      <li>Provide testing estimates based on requirements</li>
      <li>Perform software demos for stakeholders</li>
      <li>Contribute your ideas to improve software applications</li>
      <li>Verify data updates or patches for hotfixes</li>
    </ul>
    <h4 class="title is-4">What You Have</h4>
    <ul>
      <li>At least 3 years of professional software QA experience</li>
      <li>Experience testing web and mobile applications as well as APIs</li>
      <li>Basic knowledge of how web applications work</li>
      <li>A passion for delivering quality software</li>
      <li>Empathy for users and the ability to think like them</li>
      <li>Cross-browser and cross-device testing experience</li>
      <li>A curious, creative, and detail oriented mind</li>
      <li>Good SQL skills</li>
      <li>Clear and courteous written and verbal communication skills</li>
      <li>Automated testing experience (Selenium, Python, Cypress)</li>
      <li>Ability to understand C#, JavaScript, and HTML</li>
      <li>Technical degree preferred</li>
    </ul>
    <h4 class="title is-4">What We Offer</h4>
    <ul>
      <li>Excellent compensation</li>
      <li>W-2 or 1099</li>
      <li>Flexible work schedule</li>
      <li>401(k) (W-2 only)</li>
      <li>Group health insurance (W-2 only)</li>
      <li>$2500/year professional training/education</li>
      <li>Generous PTO (W-2 only)</li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    job: Object,
  },
};
</script>
